module.exports = __webpack_public_path__ + "img/scene_steampunk_backlight@2x.d5f8b447.png";